// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"3d92d788","201":"2036684f","213":"f51a832b","231":"af0b6c5f","424":"b4288210","453":"ba0a7e1a","574":"435db402","732":"9b019bda","762":"08b2abff"}[chunkId] + ".chunk.js";
};